import axios from "@/vue/api/index";
import type {
  RiskAssessmentConsultableType,
  RiskAssessmentCreatePayload,
  RiskAssessmentNewResponse,
  RiskAssessmentResult,
  RiskAssessmentStatusResponse,
  RiskAssessmentUpdatePayload,
  RiskAssessmentViewResponse
} from "../model/types";

const BASE_PATH = "/api/v1/risk_assessments";

export type FetchNewParams = {
  consultableType: RiskAssessmentConsultableType;
  consultableId: string;
};

// 起動可否・デフォルトVer・設問定義・前回入力・修正対象を一括取得する（api-endpoints.md 2）。
const fetchNew = async ({ consultableType, consultableId }: FetchNewParams): Promise<RiskAssessmentNewResponse> => {
  const response = await axios.get(`${BASE_PATH}/new`, {
    params: {
      consultable_type: consultableType,
      consultable_id: consultableId
    }
  });

  return response.data as RiskAssessmentNewResponse;
};

// ボトムバーの活性判定・修正可能期限の表示専用。カルテを開くたびに呼ばれるため、
// 過去の回答内容（要配慮個人情報）を含まないこちらを使う（api-endpoints.md 1）。
const fetchStatus = async ({ consultableType, consultableId }: FetchNewParams): Promise<RiskAssessmentStatusResponse> => {
  const response = await axios.get(`${BASE_PATH}/status`, {
    params: {
      consultable_type: consultableType,
      consultable_id: consultableId
    }
  });

  return response.data as RiskAssessmentStatusResponse;
};

const create = async (payload: RiskAssessmentCreatePayload): Promise<RiskAssessmentResult> => {
  const response = await axios.post(BASE_PATH, payload);

  return response.data as RiskAssessmentResult;
};

const update = async (id: string, payload: RiskAssessmentUpdatePayload): Promise<RiskAssessmentResult> => {
  const response = await axios.patch(`${BASE_PATH}/${id}`, payload);

  return response.data as RiskAssessmentResult;
};

// 相談サイドバーの「リスクアセスメント履歴」からの読み取り専用閲覧。
const fetchView = async (id: string): Promise<RiskAssessmentViewResponse> => {
  const response = await axios.get(`${BASE_PATH}/${id}`);

  return response.data as RiskAssessmentViewResponse;
};

export default { fetchNew, fetchStatus, create, update, fetchView };
